/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 02/05/22
 */

import React from 'react';
import { LayoutProps, RankedTester, rankWith, uiTypeIs } from '@jsonforms/core';
import { TextProps, TypographyProps } from '@chakra-ui/react';
import { LabelElement } from '@jsonforms/core/src/models/uischema';
import { withNamedJsonFormsLayoutProps } from '@/forms-renderers/chakra-ui/utils/withNamedJsonFormsHOC';
import merge from 'lodash/merge';
import { namedMemo } from '@/utils/namedMemo';
import ChakraLabelWithURL from '@/forms-renderers/chakra-ui/controls/ChakraLabelWithURL';

interface LabelOptions extends TypographyProps, TextProps {}

export const ChakraLabelRenderer = namedMemo('ChakraLabelRenderer', ({ uischema, visible, config }: LayoutProps) => {
    const labelElement = uischema as LabelElement;

    const defaultOptions: LabelOptions = {
        fontSize: 'sm',
        fontStyle: 'normal',
        fontWeight: undefined,
        textAlign: 'left',
    };
    const appliedUiSchemaOptions: LabelOptions = merge(defaultOptions, config, uischema.options);

    if (visible) {
        return (
            <ChakraLabelWithURL
                text={labelElement.text}
                fontSize={appliedUiSchemaOptions.fontSize}
                fontWeight={appliedUiSchemaOptions.fontWeight}
                fontStyle={appliedUiSchemaOptions.fontStyle}
                textAlign={appliedUiSchemaOptions.textAlign}
                color={appliedUiSchemaOptions.color}
            />
        );
    } else {
        return null;
    }
});

export const chakraLabelRendererTester: RankedTester = rankWith(1, uiTypeIs('Label'));

export default withNamedJsonFormsLayoutProps(ChakraLabelRenderer);
